import React from 'react'

import useGetMatchingTherapist from '@/legacy-src/components/diagnosis/client/hooks/useGetMatchingTherapist'
import { type IconSizeType } from '@/legacy-src/types/ComponentTypes'

import { RecommendedTherapistStyleMatch } from '@/src/domains/recommended-therapist/components/RecommendedTherapistStyleMatch'

type Props = {
  readonly therapistId: number
  readonly iconSize?: IconSizeType
  readonly title?: React.ReactNode
  readonly className?: string
  readonly listing?: boolean
}

const TherapeuticStyleProfile: React.FC<Props> = ({ therapistId, title, className = '', listing = false }) => {
  const { matchingTherapistData } = useGetMatchingTherapist(therapistId)

  const headline = title && <strong>{title}</strong>

  if (matchingTherapistData?.styleMatch === undefined) {
    return null
  }

  if (listing) {
    return (
      <>
        <hr className="-mx-5 -mb-1 mt-6" />
        <div className={className}>
          {headline}
          <RecommendedTherapistStyleMatch value={matchingTherapistData.styleMatch} />
        </div>
      </>
    )
  }

  return matchingTherapistData ? (
    <div className={`${className} rounded-xl bg-white p-5`}>
      {headline}
      <RecommendedTherapistStyleMatch value={matchingTherapistData.styleMatch} />
    </div>
  ) : null
}

export default TherapeuticStyleProfile
